import { Box } from "../Layout";
import { Container } from "./styles";

type Props = {
  message: string;
  borderBottom?: boolean;
};

export const SectionHelp = ({ message, borderBottom = true }: Props) => {
  return (
    <Box borderBottom={borderBottom}>
      <Container>
        <p>{message}</p>
      </Container>
    </Box>
  );
};
